// extracted by mini-css-extract-plugin
export var header = "header-module--header--a840d";
export var headerContent = "header-module--headerContent--5b520";
export var logo = "header-module--logo--6cb3b";
export var nav = "header-module--nav--4c29e";